import SurveysDelete from './SurveysDelete'
export {SurveysDelete}
export default SurveysDelete
